import { UnitStats, unitStats as stats } from './index';
import type { StatsSnapshot } from './gameplay-snapshot';
import type { GeneratorType } from '../types/game-types';
import { getModifiedTicksToGenerate } from '../store/helpers/get-modified-ticks-to-generate';

export const updateTotalStats = (state: StatsSnapshot) => {
  let total: UnitStats = {};

  const statsEntries = Object.entries(stats);
  statsEntries.forEach(([unitKey, unitStats]) => {
    if (unitKey === 'click' || unitKey === 'total') {
      return;
    }

    const statKeys = Object.keys(unitStats) as (keyof UnitStats)[];
    statKeys.map((statKey) => {
      const generator = state.generators[unitKey as GeneratorType];
      if (!total[statKey]) {
        total[statKey] = 0;
      }

      if (total[statKey] !== undefined && unitStats[statKey] !== undefined) {
        const ticksToGenerate = getModifiedTicksToGenerate(
          state.upgrades[unitKey as GeneratorType],
          generator,
          unitKey as GeneratorType,
        );
        total[statKey] += unitStats[statKey] / ticksToGenerate;
      }
    });
  });

  stats.total = total;
};
